module.exports = __webpack_public_path__ + "static/media/detalhes_caf.b0138002.png";